import React from "react";
import Page from "../components/Page";
import BackButton from "../components/BackButton";
import { Table } from "react-bootstrap";
import ScrollToTop from "../components/ScrollToTop";

const Rules = () => {
  return (
    <Page>
      <ScrollToTop />
      <div style={{ display: "flex", alignItems: "center" }}>
        <BackButton />
        <h4 style={{ margin: "0 16px" }}>Правила гри (19.02.24)</h4>
      </div>
      <h5 style={{ marginBottom: 12 }}>
        <i className="bi bi-patch-question"></i>&nbsp;Як почати грати?
      </h5>
      <p>
        ✅ Зберіть команду з 15 футболістів – 11 основних і 4 заміни. Склад має
        включати 2 голкіперів, 5 захисників, 5 півзахисників і 3 нападники.
      </p>
      <p>✅ Загальна вартість вашої команди має не перевищувати $100 млн.</p>
      <p>✅ Ви не можете взяти більше 2 футболістів одного клубу.</p>
      <p className="new-rule">
        ✅ Оберіть схему гри. Вона має включати 1 голкіпера, мінімум 3 захисники
        та мінімум 1 нападника. Схему можна змінювати кожного туру.
      </p>
      <p>✅ Кожного туру обирайте капітана – його очки подвоюються. </p>
      <p>
        ✅ Будьте уважні - якщо ви використали усі трансфери і натиснули кнопку
        «Зберегти», більше не буде можливості купувати і продавати гравців до
        закінчення туру. Ви зможете змінити лише схему, заміни і капітана.
        Дедлайн будь-яких змін у складі – за 1,5 години до початку першого матчу
        кожного туру.
      </p>
      <h5 style={{ marginBottom: 12 }}>
        <i className="bi bi-patch-question"></i>&nbsp;Як грати далі?
      </h5>
      <p className="new-rule">
        ✅ Очки для вашої команди набирають основні гравці. Запасні виходять на
        заміну автоматично, якщо основні не зіграли. Але запасний гравець може
        замінити лише футболіста того ж амплуа.
      </p>
      <p className="new-rule">
        ✅ Якщо у вас кілька запасних гравців одного амплуа, ви можете виставити
        пріоритет - хто першим стане основним. Для цього зробіть заміну на лаві
        запасних - щоб амплуа пріоритетного гравця вказувалось з цифрою 1.
      </p>
      <p>
        ✅ Після кожного туру ви можете зробити заміни і 2 трансфери – продати і
        купити 2 гравців. Перші три тури і стартовий тур після зимової паузи –
        кількість трансферів необмежена. Невикористані трансфери зберігаються та
        можуть бути використані учасниками у наступних турах.
      </p>{" "}
      <p>
        ✅ Перенесені матчі будуть прикріплятись до туру після цього матчу.
        Наприклад, якщо перенесений матч буде зіграно між 20-м і 21-м турами, то
        він буде прикріплений до 21-го туру.
      </p>
      <p className="new-rule">
        ✅ Виключенням з попереднього правила є матчі першого кола{" "}
        <strong>Олександрія - Оболонь </strong> і{" "}
        <strong>Минай - Динамо</strong>, які були перенесені після завершення
        дедлайну турів. Очки за ці матчі будуть нараховані, коли вони
        відбудуться - згідно складів команд Фентезі, які були зроблені восени.
      </p>
      <h5 style={{ marginBottom: 12 }}>
        <i className="bi bi-patch-question"></i>&nbsp;Як нараховуються бали?
      </h5>
      <p>
        ✅ Гравці набирають очки в залежності від власних дій і результатів
        їхніх команд. Всі данні ми отримуємо від постачальника статистики і не
        можемо їх змінювати.{" "}
      </p>
      <p className="new-rule">
        ✅ У разі, коли одній з команд зараховується технічна перемога (іншій -
        технічна поразка), усі футболісти команди-переможця отримують очки:
        голкіпери та захисники 6 очок, півзахисники 4 очки, нападники 3 очки.{" "}
        Відповідно усі футболісти команди, що програла, отримують 0 очок. При
        цьому такі футболісти не можуть бути замінені за рахунок автозаміни.
      </p>
      <Table striped size="sm">
        <thead>
          <tr>
            <th>Правило</th>
            <th>Бали</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>За перебування на полі до 60 хвилин</td>
            <td>1</td>
          </tr>
          <tr>
            <td>
              За перебування на полі 60 та більше хвилин (без врахування
              доданого часу)
            </td>
            <td>2</td>
          </tr>
          <tr>
            <td>За кожний гол голкіпера або захисника</td>
            <td>6</td>
          </tr>
          <tr>
            <td>За кожний гол півзахисника</td>
            <td>5</td>
          </tr>
          <tr>
            <td>За кожний гол нападника</td>
            <td>4</td>
          </tr>
          <tr>
            <td>За кожний гольовий асист голкіпера</td>
            <td>4</td>
          </tr>
          <tr>
            <td>За кожний гольовий асист захисника або півзахисника</td>
            <td>3</td>
          </tr>
          <tr>
            <td>За кожний гольовий асист нападника</td>
            <td>2</td>
          </tr>
          <tr>
            <td>За сухий матч голкіпера або захисника***</td>
            <td>4</td>
          </tr>
          <tr>
            <td>За сухий матч півзахисника***</td>
            <td>1</td>
          </tr>
          <tr>
            <td>
              За вольову перемогу (команда першою пропустила, але перемогла)*
            </td>
            <td>1</td>
          </tr>
          <tr>
            <td>
              За кожні забиті командою 2 голи для нападника або півзахисника*
            </td>
            <td>1</td>
          </tr>
          <tr>
            <td>
              За кожні пропущені командою 2 голи для голкіпера або захисника*
            </td>
            <td>-1</td>
          </tr>
          <tr>
            <td>За жовту картку**</td>
            <td>-1</td>
          </tr>
          <tr>
            <td>За червону картку**</td>
            <td>-3</td>
          </tr>
          <tr>
            <td>За автогол</td>
            <td>-2</td>
          </tr>
        </tbody>
      </Table>
      <p>* - футболіст має знаходитися на полі мінімум 60 хвилин </p>
      <p>
        {" "}
        ** - якщо футболіст отримує дві жовті та автоматичну червону, то
        рахуватиметься тільки червона картка{" "}
      </p>
      <p className="new-rule">
        *** - сухий матч зараховується футболісту, якщо він провів на
        футбольному полі мінімум 60 хвилин та його команда не пропустила у той
        час, коли він перебував у грі.
      </p>
      <h5 style={{ marginBottom: 12 }}>
        <i className="bi bi-patch-question"></i>&nbsp;Що ще треба знати?{" "}
      </h5>
      <p>
        ✅ Очки вашої команди нараховуються в 3 рейтингах – основний, ліга
        вболівальників вашого клубу і щомісячний. Змінити улюблений клуб можна
        лише раз.{" "}
      </p>
      <p>
        ✅ 10 клубів подарують ігрову футболку переможцю своєї ліги:{" "}
        <strong>Динамо</strong> (плюс автограф гравця), <strong>Шахтар</strong>{" "}
        (плюс мяч з автографами гравців і фото з капітаном для клубних
        соцмереж), <strong>Олександрія</strong> (плюс горнятко, бейсболка і шарф
        за 2 і 3 місця), <strong>Рух</strong> (плюс екскурсія по академії і
        відвідування тренування команди), <strong>Чорноморець</strong>,{" "}
        <strong>Верес</strong>, <strong>Кривбас</strong>,{" "}
        <strong>Металіст 1925</strong>, <strong>ЛНЗ</strong>,{" "}
        <strong>Полісся</strong>, <strong>Минай</strong> і{" "}
        <strong>Карпати</strong>. Переможець кожного місячного рейтингу отримає
        футболку з магазину{" "}
        <a target="_blank" rel="noreferrer" href="https://tatotake.store">
          Tatotake.Store
        </a>
        . Переможець загального рейтингу за підсумками сезону отримає світшот
        або худі з магазину{" "}
        <a target="_blank" rel="noreferrer" href="https://tatotake.store">
          Tatotake.Store
        </a>
        , а гравці, які зайняли 2-10 місця – футболки.
      </p>
      <p>
        ✅ Нарахування очок та оновлення рейтингів відбувається після завершення
        поточного туру УПЛ.
      </p>
      <p>
        ✅ Підпишіться на{" "}
        <a
          href="https://t.me/+VHBlTupWofg1Njgy"
          target="_blank"
          rel="noreferrer"
        >
          телеграм-канал нашої Фентезі УПЛ
        </a>{" "}
        – там ми будемо нагадувати зробити зміни в складі перед стартом кожного
        туру, повідомляти про важливі новини і відповідати на ваші
        питання/зауваження.
      </p>
    </Page>
  );
};

export default Rules;
